import { render, staticRenderFns } from "./DialogueManagement.vue?vue&type=template&id=2dda107a&scoped=true"
import script from "./DialogueManagement.vue?vue&type=script&lang=js"
export * from "./DialogueManagement.vue?vue&type=script&lang=js"
import style0 from "./DialogueManagement.vue?vue&type=style&index=0&id=2dda107a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda107a",
  null
  
)

export default component.exports